<template>
  <div class="version-toggle" :class="`version-toggle--${theme}`">
    <div class="version-toggle__container">
      <button
        class="version-toggle__option"
        :class="{ 'is-active': modelValue === 'standard' }"
        @click="handleChange('standard')"
      >
        <span class="version-toggle__text">标准版</span>
      </button>
      <button
        class="version-toggle__option"
        :class="{ 'is-active': modelValue === 'professional' }"
        @click="handleChange('professional')"
      >
        <span class="version-toggle__text">专业版</span>
      </button>
      <div
        class="version-toggle__slider"
        :class="{ 'is-professional': modelValue === 'professional' }"
      ></div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue'

const props = defineProps({
  /**
   * 当前选中的版本
   * @values 'standard', 'professional'
   */
  modelValue: {
    type: String,
    default: 'professional',
    validator: (value) => ['standard', 'professional'].includes(value)
  },
  /**
   * 主题色
   * @values 'football', 'basketball'
   */
  theme: {
    type: String,
    default: 'football',
    validator: (value) => ['football', 'basketball'].includes(value)
  },
  /**
   * 尺寸
   * @values 'default', 'small'
   */
  size: {
    type: String,
    default: 'default',
    validator: (value) => ['default', 'small'].includes(value)
  }
})

const emit = defineEmits(['update:modelValue', 'change'])

/**
 * 处理版本切换
 */
const handleChange = (version) => {
  if (version === props.modelValue) return
  
  emit('update:modelValue', version)
  emit('change', version)
}
</script>

<style scoped lang="scss">
.version-toggle {
  display: inline-flex;
  align-items: center;
  
  &__container {
    position: relative;
    display: flex;
    width: 120px;
    height: 32px;
    background: $bg-white;
    border-radius: 20px;
    border: 1px solid $border-color;
    padding: 2px;
    box-sizing: border-box;
  }
  
  &__option {
    position: relative;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 26px;
    background: transparent;
    border: none;
    border-radius: 20px;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    z-index: 2;
    
    // 只有未选中的选项才在 hover 时改变颜色
    &:not(.is-active):hover {
      .version-toggle__text {
        color: $color-primary;
      }
    }
    
    &.is-active {
      .version-toggle__text {
        color: $text-white;
        font-weight: 600;
      }
    }
  }
  
  &__text {
    font-size: 12px;
    font-weight: 500;
    color: $text-secondary;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    user-select: none;
    white-space: nowrap;
  }
  
  &__slider {
    position: absolute;
    top: 2px;
    left: 2px;
    width: calc(50% - 2px);
    height: 26px;
    background: $gradient-primary;
    border-radius: 20px;
    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    z-index: 1;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    
    &.is-professional {
      transform: translateX(calc(100% + 2px));
    }
  }
  
  // 足球主题
  &--football,
  &--basketball {
    // 预留主题钩子：当前无差异化，保持类名便于后续扩展
  }
}

// 小尺寸变体
.version-toggle--small {
  .version-toggle__container {
    width: 100px;
    height: 28px;
    padding: 2px;
  }
  
  .version-toggle__option {
    height: 22px;
  }
  
  .version-toggle__slider {
    height: 22px;
  }
  
  .version-toggle__text {
    font-size: 11px;
  }
}
</style>
